import { render } from "./EmployeeDetailsPageProfileGeneral.vue?vue&type=template&id=371560bf"
import script from "./EmployeeDetailsPageProfileGeneral.vue?vue&type=script&lang=ts"
export * from "./EmployeeDetailsPageProfileGeneral.vue?vue&type=script&lang=ts"
script.render = render

export default script